import Vue from "vue";

export default {
  getAttendanceReport({ state }, reportParams) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/attendance/reports/${state.reportParams.type}`, reportParams)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getEssAttendanceReport({ state }, reportParams) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/attendance/me/reports/${state.reportParams.type}`, reportParams)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  downloadReport(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(
          `/attendance/reports/${params.type}/download/${params.format}`,
          params
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  downloadEssReport(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(
          `/attendance/me/reports/${params.type}/download/${params.format}`,
          params
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getDepartmentsByBranch(_, id) {
    const params = {
      ...(id != null && id[0] != "all" && { branch_ids: id }),
    };
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/organization/departments/managing-departments`, {
          params,
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getTeamsByBranch(_, id) {
    const params = {
      ...(id != null && id[0] != "all" && { branch_ids: id }),
    };
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/organization/teams`, {
          params,
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getGradesByBranch(_, id) {
    const params = {
      ...(id != null && id[0] != "all" && { branch_ids: id }),
    };
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/organization/employees/settings/get-grades`, {
          params,
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getEmployeesByBranchDept(_, data) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/organization/employees/search", { params: data })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
